import React from 'react';
import './CheckboxConsentInput.css';

export interface CheckboxConsentInputProps {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
  continueLabel: string;
  onContinue: () => void;
  disabled?: boolean;
}

const CheckboxConsentInput: React.FC<CheckboxConsentInputProps> = ({
  checked,
  label,
  onChange,
  continueLabel,
  onContinue,
  disabled = false,
}) => {
  return (
    <div className="ff-checkbox-consent">
      <label className="ff-checkbox-consent__row">
        <input
          type="checkbox"
          className="ff-checkbox-consent__input"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="ff-checkbox-consent__label">{label}</span>
      </label>
      <button
        type="button"
        className="ff-checkbox-consent__continue"
        disabled={disabled || !checked}
        onClick={onContinue}
      >
        {continueLabel}
      </button>
    </div>
  );
};

export default CheckboxConsentInput;
